'use client';
import { selectCategoryHitZones } from './xychart-canvas-model';
import type { XYChartLayout } from './xychart-types';
export interface XYChartCategoryHitZonesProps {
    layout: XYChartLayout;
    onHoverCategory: (categoryIndex: number) => void;
}
export function XYChartCategoryHitZones({ layout, onHoverCategory, }: XYChartCategoryHitZonesProps) {
    return (<>
      {selectCategoryHitZones({ layout }).map((zone) => (<rect data-el="Cmarkdownxychart/CategoryHitZones/Entry" key={`hit-${zone.categoryIndex}`} x={zone.x} y={zone.y} width={zone.width} height={zone.height} fill="transparent" onMouseEnter={() => {
                onHoverCategory(zone.categoryIndex);
            }}/>))}
    </>);
}
